module.exports = __webpack_public_path__ + "static/media/sparkle.0ca3c843.mp4";